export default __webpack_public_path__ + "static/media/bg-curvy-desktop.953dbf39.svg";